import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Cursor01 = function Cursor01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12.9999 12.9999 6 6m-1.0359-8.2487-5.0107 1.7019c-.137.0465-.2055.0698-.2625.1089a.5.5 0 0 0-.1288.1288c-.0391.057-.0624.1255-.1089.2625l-1.7019 5.0107c-.211.6214-.3166.932-.4816 1.026a.5.5 0 0 1-.465.0156c-.1709-.0826-.297-.3855-.5494-.9912L3.747 4.7931c-.2342-.562-.3512-.843-.2943-1.0188a.5.5 0 0 1 .3216-.3216c.1758-.057.4568.0601 1.0188.2943l13.2213 5.5082c.6057.2524.9086.3785.9912.5495a.5.5 0 0 1-.0156.4649c-.094.165-.4046.2706-1.026.4816"
    })
  }));
};
export default Cursor01;